import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MonitorService {

  constructor(private http: HttpClient) { }
  // monitor flow
  getTraffic(deviceId: string, range: string, group: string) {
    return this.http.get<any>(
      `${environment.endpoints.monitor}/${deviceId}/traffic`,
      { params: { range, group } }
    );
  }
  getDistinctFlows(deviceId: string, range: string, group: string) {
     return this.http.get<any>(
      `${environment.endpoints.monitor}/${deviceId}//flows/distinct`,   
      { params: { range, group } }
    );
  }
  // xdr
  getXdrTop(deviceId: string, range: string, group: string) {
    return this.http.get<any>(
      `${environment.endpoints.xdr}/${deviceId}/top`,
      { params: { range, group } }
    );
  }
}
